// import * as Helper from "../utils/Helper";

export default {
    ENTITY_TYPE: {
        PORTAL: "portal",
        MEMBER: "member",
        ACCOUNT: "account",
        NETWORK: "network",
        SPORT: "sport",
        LEAGUE: "league",
        DIVISION: "division",
        REGULARGAME: "regulargame",
        PLAYOFFGAME: "playoffgame",
        TEAM: "team",
        SPORTTEAM: "sportteam",
        SPORTTEAMGAME: "sportteamgame",
        CLUB: "club",
        FITNESS: "fitness",
        INTRAMURAL: "intramural",
        PLAYOFF: "playoff",
        CONVERSATION: "conversation",
        FITNESSSESSION: "fitnesssession",
        RESERVATION: "reservation",
        NETWORKMADNESS: "networkmadness",
        MADNESS: "madness",
    },
    PAGE_TYPES: {
        FRONTPAGE: 'FrontPage',
        HOME: 'Home',
        MEMBER: 'Member',
        PLAYCARD: 'PlayerCard',
        SCHOOL: 'School',
        SPORT: 'Sport',
        LEAGUE: 'League',
        DIVISION: 'Division',
        TEAM: 'Team',
        GROUP: 'Group',
        SCHOOLCAMPUSCUP: 'SchoolCampusCup',
        CAMPUSCUP: 'CampusCup',
        CLUB: 'Club',
        FITNESS: 'Fitness',
        INTRAMURAL: 'Intramural',
        MADNESS: 'Madness',
        NETWORKMADNESS: 'NetworkMadness',
        PLAYOFF: 'Playoff',
        REGULARGAME: 'regulargame',
        PLAYOFFGAME: 'playoffgame',
        RESERVATION: 'Reservation',
        CONVERSATION: 'Conversation',
        EQUIPMENT: 'Equipment',
        OFFERING: 'Offering',
    },
    WAITLIST_DEFAULT_ID: "0",
    CODES: {
        SPA_CLIENT_OLD: -100,
        TO_BE_AUTHENTICATED: -1,
        ACCESS_VIOLATION: -2,
        SPA_DISABLED: -3,
        SSO_VIOLATED: 108,
        MUST_BE_SCHOOL_MEMBER: -8,
        ACCOUNT_NOT_EXIST: 100,
        INACTIVE_ACCOUNT: 101,
        MUST_IN_WAITLIST_DUE_TO_MIN_PLAYER_BOUND: 119,
        MUST_IN_WAITLIST_DUE_TO_MIN_RESTRICT_TEAM_JOIN: 120,
        LEAGUE_CLOSED_FOR_JOIN: 123,
        ALREADY_JOINED_TEAM: 125,
        TEAM_JOIN_PENDING: 126,
        INVITED_MEMBER_JOIN: 127,
        ADDED_MEMBER_BY_ADMIN: 128,
        NEED_PASS_QUIZ: 138,
        INVALID_NETWORK_EMAIL: 140,
        REQUIRE_PAYMENT: 141,
        REQUIRE_SIGN_WAIVERS: 142,
        REQUIRE_SET_PASSWORD: 143,
        REQUIRE_COMPLETE_REGISTRATION: 144,
        REQUIRE_LINK_FACEBOOK: 145,
        REQUIRE_HTTPS: 146,
        SESSION_FULL: 149,
        REQUIRE_ACCEPT_TERM: 160,
        NEED_REDIRECT_TO_PAYMENT: 162,
        RECAPTCHA_VALIDATION_FAIL: 157,
        REMOVE_TEAM_CAPTAIN_ERROR: 170,
        REQUIRE_SSO_SET_PASSWORD: 176,
        ALREADY_SCHOOL_MEMBER: 179,
        PENDING_JOIN_SCHOOL_REQUEST: 180,
        HAVE_NO_JOINED_SCHOOL: 183,
        NOT_SESSION_MEMBER: 185,
        NOT_GAME_MEMBER: 186,
        REQUIE_VALID_TEAM: 187,
        TEAM_DOES_NOT_EXIST: 188,
        NEED_TO_CHOOSE_PACKAGE: 189,
        NOT_EVENT_MEMBER: 191,
        CAN_JOIN_AS_NOMAD: 192,
        NEED_CREATE_NEW_ACCOUNT: 202,
        CHECK_IN_SESSION_WAITLIST_MEMBER: 206,
        NOT_ENABLE_PAY_PACKAGE: 208,
        GAME_NOT_EXIST: 209,
        NOT_MOST_RECENT_WAIVER: 210,
        CHECK_REQUIREMENTS_TIPS : 302,
        SID_IN_USE: 400,
        SID_PENDING_REQUEST: 401,
        SID_VERIFY_FAILED: 402,
        SID_NOT_MATCH: 404,
        SID_NOT_IN_SHEET: 405,
        FITNESS_DISABLED: 600,
        CLUB_DISABLED: 700,
        RESERVATION_DISABLED: 800,
    },
    PAGES: {
        SPA_MEMBER_HOME: '/spa/member/player',
        MEMBER_HOME: '/Members/Home.aspx',
        SIGN_WAIVER_REQUESTS: '/Members/SignWaiverReuqests.aspx',
        CHANGE_PASSWORD: '/Members/ChangePassword.aspx',
        COMPLETE_REGISTRATION: '/Members/CompleteRegistration.aspx',
        PAGE_NOT_FOUND: '/spa/portal/notfound',
        LINK_FACEBOOK: '/Members/LinkFacebook.aspx',
        SSO_SET_PASSWORD:'/spa/account/changepassword?SSOSetPass=True',
        SIGN_WAIVER_PROMPT: '/spa/member/signwaiverprompt',
    },
    REQUEST_TYPE: {
        UNKNOWN: -1,
        FRIEND_REQUEST: 0,
        TEAM_MEMBER_REQUEST: 1,
        TEAM_MEMBER_INVITATION: 2,
        GROUP_MEMBER_INVITATION: 3,
        GROUP_MEMBER_REQUEST: 4,
        CHANLLENGE_REQUEST: 5,
        GROUP_REQUEST: 6,
        SCHOOL_MEMBER_REQUEST: 7,
        OFFICIAL_REQUEST: 8,
        STUDENT_REQUEST: 9,
        TEAM_RENAME_REQUEST: 10,
        GROUP_RENAME_REQUEST: 11,
        GAME_RESCHEDULE_REQUEST: 12,
        EXCUTE_GAME_RESCHEDULE_REQUEST: 13, // ONLY SEND TO SCHOOL ADMINS(CONFIRM RESCHEULEING OR NOT AFTER GAME_RESCHEDULE_REQUEST WAS ACCEPTED BY BOTH TEAM ADMINS)
        GAME_CANCEL_REQUEST: 14,
        FORM_REVIEW_REQUEST: 15,
        STUDENT_TOBE_CHAIR_REQUEST: 16, // NO NEED FOR NOW
        TRAVEL_REQUEST: 17,
        PERSONAL_TRAINING_SESSION_REQUEST: 18,
        SPORT_TEAM_MEMBER_REQUEST: 19,
        SPORT_TEAM_MEMBER_INVITATION: 20,
    },
    PRIMARY_COLOR: "#19589b",
    SECONDARY_COLOR: "#eea236",
    BACKGROUND_TASK_STORAGE_KEY: "BACKGROUND_TASK_STORAGE_KEY",
    OFFLINE_STORAGE_KEY: "OFFLINE_STORAGE_KEY",
    OFFLINE_STORAGE_GAME_KEY: "OFFLINE_STORAGE_GAME_KEY",
    FEED_BACK_HELPER_STORAGE_KEY: "FEED_BACK_HELPER_STORAGE_KEY",
    PUSH_NOTIFICATION_STORAGE_KEY: "PUSH_NOTIFICATION_STORAGE_KEY",
    NOTIFIED_VERSION_STORAGE_KEY: "NOTIFIED_VERSION_STORAGE_KEY",
    BACKGROUND_TASK_TYPE: {
        API_CALL: 1
    },
    BACKGROUND_TASK_QUEUE_TYPE: {
        GAME: "GAME TASK",
    },
    AUTO_SEARCH: {
        TIMEOUT_MIN: 1000,
        LENGTH_MIN: 3
    },
    SCHEDULE_GAMES_PAGE_SIZE: 10,
    SECTION_LAYOUT_UPDATED_DELAY: 400,
    SCREENS: {
        LEAGUE: {
            TABS: {
                SCHEDULE: "schedule"
            }
        }
    },
    ADS_TYPE: {
        ADMOB: "admob",
        MOPUB: "mopub",
        FACEBOOK: "facebook",
        DFP: "dfp",
        DFPUSA: "dfpusa",
        DFPAMAZON: "dfpamazon",
        MOPUBAMAZON: "mopubamazon",
        APPODEAL: "appodeal",
        FREESTAR: "freestar",
    },
    BANNER_ADS_FREQUENCY: 3,
    ACTIVITY_TAG_TYPE: {
        UNKNOWN: -1,
        SCHOOL: 0,
        SPORT: 1,
        LEAGUE: 2,
        DIVISION: 3,
        TEAM: 4,
        FRIENDS: 5,
        GROUP: 6,
        SCHOOL_CAMPUS_CUP: 7,
        CAMPUS_CUP: 8,
        MEMBER: 10,
        SPORT_GAME: 11,
        PLAYOFF_GAME: 12,
        CLUB: 100,
        FITNESS: 200,
        INTRAMURALS: 300,
        MY_FRIENDS: 400,
        MY_TEAMS: 401,
        MY_GROUPS: 402
    },
    ACTIVITY_TYPE: { MESSAGE: 1, POLL: 2, EVENT: 3, ANNOUNCEMENT: 4 },
    USER_GUEST: "guest",
    USER_ADMIN: "admin",
    SITE_NAME: "IMLeagues", //Helper.isCNCulture()? "IMLeagues" :"IMLeagues",
    SITE_DOMAIN: "IMLeagues.com",
    CALL_UP_APP_TYPE:{
        UNKNOWN : 0,
        REVIEW_FROM : 1,
        FILL_FORM: 2,
        MAKE_PAYMENT: 3,
        SSO_LOGIN: 4,
        EMAIL_LOGIN: 5,
        ACTIVATE_ACCOUNT: 6,
    },
    FACILITY_STATUS:{NONE:-1,OPEN:0,PENDING:1,CLOSED:2},
    STRINGS:{
        BYE: "Bye"
    },
    SPORT_TEAM_OWNER_TYPE: {
        OLD_CLUB_LINK: 0, // THIS IS THE OLD SPORT TEAM THAT FOR LINK TEAM FUNCTION
        INTRAMURAL: 1, // THIS IS INTRAMURAL CREATED SPORT TEAM
        CLUB: 2, // THIS IS CLUB CREATED SPORT TEAM
        INDEPENDENT: 3 //FOR NOW WE WILL NOT SUPPORT THIS.
    },
    SUPPORTED_LANGUAGES: [
        { code: "en", name: "English", culture: "en-US" },
        { code: "zh", name: "中文", culture: "zh-CN" },
    ],
    FACILITY_CALENDAR_SCOPE_FILTER: {
        INTRAMURAL: 1,
        CLUB: 2,
        FITNESS: 4,
        ENTIRE_NETWORK: 7,
    },
    OFFERING_CALENDAR_SCOPE_FILTER: {
        INTRAMURAL: 1,
        CLUB: 2,
        FITNESS: 4,
        ENTIRE_NETWORK: 7,
    },
};
